module.exports = __webpack_public_path__ + "static/media/242 Park - Sign Posting 1.9712a9c8.jpeg";